import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRecoilCallback } from 'recoil';
import { showModal } from 'src/products/shell/redux/modals/actions';
import { taxAssessorsQuery } from './recoil';
import { usaDataFormatter } from 'src/products/core-prospect/components/PropertyAddressSummary/dataFormatter/usaDataFormatter';
import { useSnackbarCherre } from 'src/products/core-prospect/hooks';
import * as F from './formatters';
import * as T from './types';
import * as U from './utils';

export const useCreateDealV2 = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbarCherre();

  const [loading, setLoading] = useState(false);

  const showCreateDialog = useRecoilCallback(
    ({ snapshot }) =>
      async (taxId?: number) => {
        if (loading) {
          return;
        }

        setLoading(true);

        //retain snapshot for async operations
        const release = snapshot.retain();

        try {
          // get data

          const taxAssessorsResult = taxId
            ? await snapshot.getPromise(taxAssessorsQuery({ ids: [taxId] }))
            : { tax_assessor_v2: [] };

          const taxAssessors = taxAssessorsResult.tax_assessor_v2
            .map<T.DataFormatter | null>((tax) => {
              return tax ? usaDataFormatter(tax) : null;
            })
            .filter((t): t is T.DataFormatter => Boolean(t));

          const assetsCount = taxAssessors.length;

          if (assetsCount === 1) {
            dispatch(
              showModal('DEALCLOUDV2', {
                propertyInfo: {
                  propertyDealData: F.taxAssessorToDealData(taxAssessorsResult),
                  assets: taxAssessors,
                },
                mode: 'create',
              })
            );
          } else {
            dispatch(showModal('DEALCLOUD_PORTFOLIO', { mode: 'create' }));
          }
        } catch (e) {
          const msg = U.getErrorMsg(e);
          enqueueSnackbar(msg, U.getSnackbarProps('error'));
          throw e;
        } finally {
          setLoading(false);
          release();
        }
      },
    [loading]
  );

  return [showCreateDialog, loading] as const;
};
